import { Link } from 'react-router-dom';
import FeaturedProductCard from './FeaturedProductCard';
import { FeaturedProductsProps } from '../../../interface/interface';

const FeaturedProducts = ({
  title,
  products,
  viewAllHref,
  isGuest = false,
}: Readonly<FeaturedProductsProps>) => {
  if (!products?.length) return null;

  return (
    <section className="container-standard">
      <div className="mb-6 flex items-center justify-between">
        <h2 className="text-xl font-semibold text-primary-blue-500 md:text-2xl">
          {title}
        </h2>
        <Link
          to={viewAllHref}
          className="text-sm font-semibold text-primary-blue-500 hover:underline"
        >
          View All &gt;
        </Link>
      </div>

      <ul className="grid grid-cols-2 gap-4 md:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-6 md:gap-6">
        {products?.map((product) => (
          <li key={product.id}>
            <FeaturedProductCard product={product} isGuest={isGuest} />
          </li>
        ))}
      </ul>
    </section>
  );
};

export default FeaturedProducts;
